import React from 'react';
import { motion } from 'framer-motion';
export function CostSection() {
  const costs = [{
    sin: 'Precios fijados sin calcular costos',
    costo: 'Perdés entre $6.000 y $15.000 por servicio que hacés'
  }, {
    sin: 'Sin política de seña activa',
    costo: '4 cancelaciones/mes = $720.000 en pérdidas anuales'
  }, {
    sin: 'Sin sistema de fidelización',
    costo: 'El 40% de tus clientas no vuelve aunque el trabajo sea bueno'
  }, {
    sin: 'Sin filtro de clientas tóxicas',
    costo: 'El 30% de tu energía para clientas que generan el 10%'
  }, {
    sin: 'Sin control de caja',
    costo: 'Imposible saber si el negocio gana o pierde'
  }, {
    sin: 'Próxima semana igual que esta',
    costo: 'El mismo ciclo, el próximo año'
  }];
  return <section className="py-20 px-4 pt-[25px] pb-[25px]" data-id="element-111">
      <div className="max-w-4xl mx-auto" data-id="element-112">
        <div className="text-center mb-12" data-id="element-113">
          <h2 className="text-3xl md:text-4xl font-black mb-4" data-id="element-114">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12" data-id="element-115">
          {costs.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-dark-card border border-dark-border p-6 rounded-xl" data-id="element-116">
              <div className="text-gray-400 text-sm mb-2" data-id="element-117">
                Sin Ultrapack: {item.sin}
              </div>
              <div className="text-red-400 font-bold" data-id="element-118">
                Costo real: {item.costo}
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-119">
          <p className="text-2xl md:text-3xl font-black text-white" data-id="element-120">
            El próximo lunes puede ser diferente.{' '}
            <span className="text-brand" data-id="element-121">💅</span>
          </p>
        </div>
      </div>
    </section>;
}